import React from 'react';
import { IconProps } from './model/IconInterface';

const BasketIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor', fill }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? color : 'none'}
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <line x1="3" y1="10" x2="21" y2="10" /><path d="M4.5 10l2.2 10.4A2 2 0 0 0 8.7 22h6.6a2 2 0 0 0 2-1.6L19.5 10" /><path d="M9 10l3-7 3 7" />
    </svg>
  );
};

export default BasketIcon;
